import axios from 'axios';
import { message } from 'antd';

// 创建 axios 实例
const service = axios.create({
  baseURL: (import.meta.env.VITE_API_BASE_URL || 'https://usdc-api.defiportal.org') + '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 确保 params 是一个对象
    if (config.params) {
      // 移除 undefined 和 null 的参数
      Object.keys(config.params).forEach(key => {
        if (config.params[key] === undefined || config.params[key] === null) {
          delete config.params[key];
        }
      });
    }
    
    console.log('Request config:', {
      url: config.url,
      method: config.method,
      params: config.params,
      data: config.data,
      headers: config.headers
    });
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 如果响应成功，直接返回响应数据
    if (response.status === 200) {
      return response.data;
    }
    // 如果响应不成功，返回一个带有错误信息的对象
    return {
      code: response.status,
      message: '请求失败',
      data: null
    };
  },
  (error) => {
    console.error('Request error:', error);
    if (error.response?.status === 401) {
      // 清除本地存储的认证信息
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      // 重定向到登录页
      window.location.href = '/login';
    }
    // 返回一个带有错误信息的对象
    return Promise.reject({
      code: error.response?.status || 500,
      message: error.response?.data?.message || '请求失败',
      data: null
    });
  }
);

// 扩展 axios 实例的类型定义
declare module 'axios' {
  export interface AxiosInstance {
    get<T = any>(url: string, config?: any): Promise<T>;
    post<T = any>(url: string, data?: any, config?: any): Promise<T>;
    put<T = any>(url: string, data?: any, config?: any): Promise<T>;
    delete<T = any>(url: string, config?: any): Promise<T>;
  }
}

export default service; 